export const defaultOverlayProps = {
  width: "40vw",
  height: "40vh",
  title: "defaultTitle",
  children: undefined,
};
